import { gql } from '@apollo/client';

// Persists the partnership editors (description, workforce denominator, volunteering
// opportunities, employment categories). Volunteering/employment are replace-all.
export const UPDATE_PARTNERSHIP = gql`
mutation UpdatePartnership(
  $supporterId: Int!
  $description: String
  $workforceTotal: Int
  $volunteerRoles: [VolunteerRoleInput!]
  $employmentCategories: [EmploymentCategoryInput!]
) {
  updatePartnership(
    supporterId: $supporterId
    description: $description
    workforceTotal: $workforceTotal
    volunteerRoles: $volunteerRoles
    employmentCategories: $employmentCategories
  ) {
    id
  }
}`;
